import { render, staticRenderFns } from "./EditKeysPage.vue?vue&type=template&id=1277b59e&scoped=true&"
import script from "./EditKeysPage.vue?vue&type=script&lang=js&"
export * from "./EditKeysPage.vue?vue&type=script&lang=js&"
import style0 from "./EditKeysPage.vue?vue&type=style&index=0&id=1277b59e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1277b59e",
  null
  
)

export default component.exports